<div
  class="modal fade"
  id="confirmExitModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="confirmExitModalLabel"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
  [ngClass]="{ 'pointer-none': showExitConfirmModal }"
>
  <div
    class="modal-dialog modal-dialog-centered modal-sm"
    role="document"
    style="width: 30%"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Confirm Exit</h4>
        <button type="button" class="close">
          <img
            src="./assets/icons/close.svg"
            (click)="fnCloseConfirmExitModal()"
            alt="Close"
          />
        </button>
      </div>
      <div class="modal-body position-relative px-0">
        <div class="content p-3 py-0">
          <div class="confirmation-message">
            <p  class="f-14">
              This action can't be undone. Make sure following:
            </p>
            <ul>
              <li *ngIf="showMessage">
                Remove any future allocations for this employee
              </li>
              <li>
                Any line reportings from this employee has been transitioned
              </li>
              <li *ngIf="showMessage">
                Assigned IT assets has been returned
              </li>
            </ul>
            <p>
              Are your sure you want to mark this employee's status as Exit?
            </p>

          </div>
          <div class="btn-cont">
            <button
              type="button"
              class="btn btn-primary btn-sm"
              (click)="confirmExitEmployee()"
            >
              Yes
            </button>
            <button
              type="button"
              class="btn btn-white btn-sm btn-modalDelete"
              (click)="fnCloseConfirmExitModal()"
              data-dismiss="modal"
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
